baseApp.directive('entryList', [function () {
    return {
        templateUrl: '/public/directives/entrylist.html',
        scope: {
            items: '=',
            displayField: '@',
            addItems: '&',
            onRemove: '&?',
            id: '@',
            root: '=',
            field: '@',
            icons: '=',
            immutable: '@',
            forcePopup: '@',
            capitalize: '@',
            stopProp: '=',
            fields: '=',
            bigMode: '=?',
            editor: '@',
            addTagCaption: '@',
        },
        controller: function ($scope, $state, $element, $timeout) {

            let lookupTypes = ['GROUP', 'SYSTEMGROUP', 'HOSTSUBNET','CustomCategory', 'ACCESSLOGIN'];

            $scope.entryId = $scope.$id;
            $scope.hoveredItem;
            let lookupTimeout = null;

            $scope.addNew = function ($event) {
                if ($scope.stopProp) {
                    $event.stopPropagation();
                }
                $scope.addItems({ item: $scope.root, field: $scope.field, id: $scope.id + '_add' });
            };

            $scope.remove = function (index, $event) {
                if ($scope.stopProp) {
                    $event.stopPropagation();
                }

                const deleted = $scope.items.splice(index, 1)[0];
                if ($scope.onRemove) {
                    $scope.onRemove({deleted: deleted});
                }
                $scope.lookupPopup.pos = null;
            };

            $scope.lookupPopup = {
                ready: false,
            };

            $scope.mouseEnterEntry = function (item, $event) {
                if ($scope.hoveredItem !== item) {
                    if (lookupTimeout) {
                        $timeout.cancel(lookupTimeout);
                    }
                    if (lookupTypes.includes(item.type)) {
                        const $target = $($event.currentTarget);
                        lookupTimeout = $timeout(function() {
                            if ($scope.hoveredItem === item) {
                                getLookupData(item, $target);
                            }
                        }, 100, false);
                    }
                }

                $scope.hoveredItem = item;
            };

            function getLookupData(item, $target) {
                var $targetPos = $target.position();

                $scope.lookupPopup.params = {
                    id: item.id,
                    type: item.type,
                };
                $scope.lookupPopup.params[item.type.toLowerCase() + 'Id'] = item.id;

                if (item.type === 'GROUP' || item.type === 'SYSTEMGROUP') {
                    $scope.lookupPopup.settingsTitle = 'Groups Configuration';
                    $scope.lookupPopup.settingsState = 'app.groups';
                    $scope.lookupPopup.method = 'POST';
                    $scope.lookupPopup.url = '/groupItems';
                    $scope.lookupPopup.items = true;
                    $scope.lookupPopup.process = null;
                    if (item.type === 'SYSTEMGROUP') {
                        $scope.lookupPopup.params.importType = "SYSTEM";
                        $scope.lookupPopup.params.accountId = $state.params.accountId;
                    }
                } else if (item.type === 'CustomCategory') {
                    $scope.lookupPopup.settingsTitle = 'Categories Configuration';
                    $scope.lookupPopup.settingsState = 'app.categories';
                    $scope.lookupPopup.url = '/getCategory';
                    $scope.lookupPopup.items = true;
                    $scope.lookupPopup.process = null;
                } else if (item.type === 'ACCESSLOGIN') {
                    $scope.lookupPopup.settingsTitle = 'VPN Users Configurations';
                    $scope.lookupPopup.settingsState = 'app.logins';
                    $scope.lookupPopup.method = 'POST';
                    $scope.lookupPopup.url = '/getAccessLoginMinimal';
                    $scope.lookupPopup.params.accountId = $state.params.accountId;
                    $scope.lookupPopup.items = true;
                    $scope.lookupPopup.process = null;
                }
                else {
                    $scope.lookupPopup.method = 'GET';
                    $scope.lookupPopup.url = '/getSubnetInfo';
                    $scope.lookupPopup.process = function (data) {
                        if (!data) return '';

                        return data.siteName + (data.interfaceName ? (' \\ ' + data.interfaceName) : '') + (data.range ? (' \\ ' + data.range) : '') + ' \\ ' + data.name + ' - ' + data.subnet ;
                    };
                    $scope.lookupPopup.params.accountId = $state.params.accountId;
                }

                $scope.lookupPopup.pos = { x: $targetPos.left + ($target.width() / 2), y: $targetPos.top + $target.height() + 10 };
                if (!$scope.bigMode) {
                    $scope.lookupPopup.pos.y = $scope.lookupPopup.pos.y - 10;
                }
            }

            $scope.mouseLeaveEntry = function (item) {
                $scope.lookupPopup.pos = null;
                $scope.hoveredItem = null;

                if (lookupTimeout) {
                    $timeout.cancel(lookupTimeout);
                }
            };

            $scope.getCaption = function(item) {
                if ($scope.displayField && item[$scope.displayField])
                return item[$scope.displayField];
                return item.display_name || getTypeFixedName(item) || item.name || item.id || item;
            };

            function getTypeFixedName(item){
                if($scope.fields){
                    let type = $scope.fields.types.filter(type => type.field.type === item.name)[0];
                    if(type){
                        return type.fixed_display_name;
                    }
                }
            }

            $scope.$on('added-item', function(e, params) {
                if ($scope.entryId === params.id) {
                    let $entryListContainer = $($element[0]).find('.entry-list-container');
                    $entryListContainer.scrollTop($entryListContainer.prop("scrollHeight"));
                }
            });

            $scope.getAddTagText = function() {
                if ($scope.addTagCaption)
                return $scope.addTagCaption;
                if (!$scope.items || $scope.items.length === 0)
                return 'Add';
                return 'Edit';
            }

            $scope.$on('$destroy', function () {
                if (lookupTimeout)
                    $timeout.cancel(lookupTimeout);
            });
        },
        link: function($scope) {
            function setBigMode() {
                $scope.bigMode = $scope.bigMode || !$scope.editor;

                if ($scope.editor && !$scope.bigMode) {
                    $scope.hideEditor = function() {
                        $scope.$broadcast('hide-editor', $scope.$id + $scope.field);
                    };

                    $scope.showEditor = function() {
                        $scope.$broadcast('show-editor', $scope.$id + $scope.field);
                        $scope.loadEditor = true;
                    };
                }
            }

            setBigMode();
        }
    };
}]);
